import { useContext, useEffect, useState } from 'react';
import { ImagenOptimizada } from 'shared-components/Components/Image/_new_web';
import { PriceTag } from 'shared-components/Components/Property/PriceTag/web';
import { Title } from 'shared-components/Components/Property/Title/web';
import { Favorite } from 'shared-components/Components/Property/Favorite/web';
import { LeadButtons } from 'shared-components/Components/Property/InformationRequest/LeadButtons/web';
import { formatMoney, showBathrooms, showBedrooms, showGuests, showM2, showRooms } from '@Utils/Functions';
import { MapCardSkeleton } from './MapCardSkeleton';
import { useWindowSize } from 'shared-components/GlobalHooks/useWindowSize';
import { fetchSearchResults } from 'src/services/search';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import { Listing } from 'shared-components';
import { CardLink } from 'shared-components/ViewFragments/SearchPage/ListingCard';
import { firstLetterToUppercase } from "src/utils/Functions";

interface MapCardProps {
    data: any,
    isActive: boolean,
    index?: number,
    currentIndex?: number,
    nextPreviousCallback?: (type, index) => void
}

export const MapCard = ({data, isActive, index, currentIndex, nextPreviousCallback} : MapCardProps) => {
	const { main_domain, country_code, translations } = useContext(ConfigStateContext);
    const screen = useWindowSize();
	const [loading, setLoading] = useState(true);
    const [property, setPorperty] = useState({} as Listing);
    const isDesktop = screen.lg || screen.xl;

    useEffect(() => {
		setLoading(true);

		const payload = {
			rows: 1,
			params: {
				id: data.id,
			},
			page: 1,
			source: 10,
		};

		fetchSearchResults(payload, main_domain)
			.then(res => {
				setPorperty(res.property);
				setLoading(false);
			})
			.catch(err => {
				console.log(err);
				setLoading(false);
			});
	}, [data.id]);

    const handleCallback = () => {
        if (nextPreviousCallback && isDesktop) {
            const type = index > currentIndex ? "next" : "";

            nextPreviousCallback(type, index)
        }
    }

    return (
        <>
            {(loading && typeof property.id === "undefined") ? <MapCardSkeleton />
            :(
                <div
                    className={`map-card ${isActive ? "map-card--active" : ""}`}
                    onMouseEnter={handleCallback}
                >
                    <CardLink
                        data={property}
                        onCancel={handleCallback}
                        className='map-card--link'
                        isActive={isActive || !isDesktop}
                    >
                        <div className='map-card__gallery'>
                            <ImagenOptimizada src={property.images?.[0]?.image} alt="Image" width={300} height={270} />
                        </div>

                        <div className='map-card__content'>
                            <div className="property-card-top">
                                <Favorite id={property.id} type={"justIcon"} />
                            </div>

                            <PriceTag
                                price={property.price}
                                operationType={property.operation_type}
                                temporalCurrency={property.temporal_currency}
                                temporalPrice={property.temporal_price}
                                commonExpenses={property.commonExpenses}
                            />

                            <Title title={property.title} hideInformation limitLength={1} level={5} />

                            <div className="lc-typologyTag">
                                {showBedrooms([Number(property.property_type.id)], Number(property.operation_type.id), country_code) && (
                                        <span className="typology-bedrooms">
                                            {(() => {
                                                const bedroomText = property.bedrooms === 0
                                                    ? "Mono"
                                                    : property.bedrooms + (property.bedrooms > 1
                                                        ? ` ${firstLetterToUppercase(translations.habs)}`
                                                        : ` ${firstLetterToUppercase(translations.hab)}`);
                                                return <span>{bedroomText}</span>;
                                            })()}
                                        </span>
                                    )}
                                {showRooms([Number(property.property_type.id)], country_code) && (
                                    <span className="typology-rooms">
                                        <span>{property.rooms == 1
                                            ? property.rooms + " Ambiente"
                                            : property.rooms + " Ambientes"}</span>
                                    </span>
                                )}
                                {showBathrooms([Number(property.property_type.id)], country_code) && (
                                    <span className="typology-bathrooms">
                                        <span>{property.bathrooms} {property.bathrooms > 1 ? "Baños" : "Baño"}</span>
                                    </span>
                                )}
                                {showM2(Number(property.operation_type.id)) && property.m2 > 0 && (
                                    <span className="typology-m2">
                                        <span>{formatMoney(property.m2)} m²</span>
                                    </span>
                                )}
                                {showGuests(Number(property.operation_type.id)) && property.guests && (
                                    <span className="typology-guests">
                                        <span>{property.guests} Huéspedes</span>
                                    </span>
                                )}
                            </div>

                            <LeadButtons
                                id={property.id}
                                owner={property.owner}
								seller={property.seller}
                                propertyLink={property?.link}
                                isInListing
                                source="card"
                                ctaToShow={{
                                    contact: true,
                                    phone: true,
                                    whatsapp: true
                                }}
                            />
                        </div>
                    </CardLink>
                </div>
            )}
        </>
    )
}